<div class="container-box shadow-none">
  <div class="d-flex gap-3 align-items-center p-3 border-bottom">
    <i class="fas fa-exclamation-triangle text-warning"></i>
    <div>
      <h6 class="mb-0" i18n>Before you connect</h6>
      <div class="text-sm">
        <ng-container i18n>Connecting changes these Airbnb settings. AdvanceCM cannot undo them.</ng-container>
      </div>
    </div>
  </div>
  <div class="p-3 d-flex flex-column gap-3">
    <!-- The @@ ids below are the auto-generated ids these headings had while they lived in step2's
         accordion. Pinning them keeps the existing translations in messages.*.xlf attached. The
         body copy that used to carry pinned ids was rewritten, so those ids were dropped on
         purpose: reusing an id after changing the English serves a stale translation of text that
         no longer says the same thing. Without an id the locales fall back to English until
         retranslated, which is the safe failure. -->
    <div>
      <strong i18n="@@3086961474070009597">Linked Calendars</strong>
      <p class="mb-0">
        <ng-container i18n
          >Airbnb removes existing links between your rentals. Import your rentals first, then relink them
          —</ng-container
        >
        <a href="http://help.tokeet.com/rental-settings/linking-rentals-together" target="_blank" i18n
          >follow this process</a
        >.
      </p>
    </div>

    <div>
      <strong i18n>Instant Book</strong>
      <p class="mb-0" i18n>
        Airbnb switches most API-connected listings to Instant Book, so guests book without your approval. To keep
        Request to Book, contact Airbnb before connecting.
      </p>
    </div>

    <div>
      <strong i18n="@@6544535346322466351">Smart Pricing and Rule Sets</strong>
      <p class="mb-0" i18n>
        Airbnb disables Smart Pricing and ignores rule sets from its rates calendar. Set your rates in AdvanceCM
        instead, and review them after connecting.
      </p>
    </div>

    <div>
      <strong i18n>Airbnb Service Fee</strong>
      <p class="mb-0" i18n>
        Airbnb switches API-connected accounts to its host-only fee: a single 15.5% comes out of your price, and guests
        pay no separate fee. The price you set is what guests pay, so review your rates to protect your payout.
      </p>
    </div>
  </div>
</div>
